import React from 'react';
import { get_dynamic_styles } from '../../../constant/DynamicStyles';

const ListingCategory = ({ styles, data, product }) => {
  return (
    <div className="   " style={get_dynamic_styles(styles?.main_styles)}>
      <p className="  " style={get_dynamic_styles(styles?.text_styles)}>
        {product?.category?.[0]?.name}
      </p>
    </div>
  );
};

export default ListingCategory;
